import { NgModule } from '@angular/core';
import { CommonGroupRequiredDirective } from './group_required.directive';

@NgModule({
	declarations: [
		CommonGroupRequiredDirective,
	],
	exports: [
		CommonGroupRequiredDirective,
	],
})
export class CommonGroupRequiredModule {}
